<template>
    <u-page-section-wide v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-page-section-wide>
</template>

<script>
import UPageSectionWide from "@/sets/styles/pages/u-page-section-wide.vue";

export default {
    props: {},
    components: {
        UPageSectionWide,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
